module.exports = __webpack_public_path__ + "img/home-enter.03d20707.svg";